import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import avtar5 from '../../assets/images/user/avatar-5.jpg'
import { getData, putData } from '../Services/api'
import { toast } from 'react-toastify'
import JoditEditor from 'jodit-react';

const UpdateTesti = () => {
    const { id } = useParams();
    const editor = useRef(null);
    const [values, setValues] = useState({
        name: "",
        rating: "",
        review: "",
        purchased_item: "",
        avatar: null,
    })

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setValues(prev => ({
                ...prev,
                avatar: file,
            }));
        }
    };

    const fetchTestimonials = async () => {
        try {
            const res = await getData(`/testimonials/${id}`);
            if (res.status) {
                setValues(res.data || {})
            }
        } catch (error) {
            console.log("error fetch testimonials", error)
        }
    }

    useEffect(() => {
        fetchTestimonials();
    }, [id])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        try {
            const formData = new FormData();
            formData.append('name', values.name);
            formData.append('review', values.review);
            formData.append('rating', values.rating);
            formData.append('purchased_item', values.purchased_item);
            if (values.avatar) {
                formData.append('avatar', values.avatar);
            }
            const res = await putData(`/testimonials/${id}`, formData);
            if (res.status) {
                toast.success(res.message)
                navigate('/testimonials/testimonial-list');
                setValues({
                    name: "",
                    rating: "",
                    review: "",
                    purchased_item: "",
                    avatar: null,
                })
            }
        } catch (error) {
            console.log("error testimonials adding",)
            toast.error(error.data.response.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/testimonials/testimonial-list">Testimonials</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Add Testimonials
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Add Testimonials</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Add Testimonials</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-sm-12 mb-3">
                                                <label htmlFor="avatar" className="form-label">
                                                    Testimonial Image
                                                </label>

                                                <input
                                                    type="file"
                                                    id="avatar"
                                                    className="form-control"
                                                    onChange={handleImageChange}
                                                    accept="image/*"
                                                />

                                                {values.avatar && (
                                                    <img
                                                        src={
                                                            values.avatar
                                                                ? typeof values.avatar === 'string'
                                                                    ? `${values.avatar}`
                                                                    : URL.createObjectURL(values.avatar)
                                                                : avtar5
                                                        }
                                                        alt="Preview"
                                                        className="img-fluid mt-2"
                                                        style={{ maxWidth: "150px", borderRadius: "8px" }}
                                                    />
                                                )}
                                            </div>

                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">User Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter User Name"
                                                        name='name'
                                                        value={values.name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Rating</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Rating"
                                                        name='rating'
                                                        value={values.rating}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">Purchase Item</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Product"
                                                        name='purchased_item'
                                                        value={values.purchased_item}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="form-label">review</label>
                                                    <JoditEditor
                                                        ref={editor}
                                                        value={values.review}
                                                        onChange={(newContent) =>
                                                            setValues(prev => ({
                                                                ...prev,
                                                                review: newContent
                                                            }))
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-end btn-page mb-0 mt-4">
                                                <Link to="/testimonials/testimonial-list" className="btn btn-outline-secondary">Cancel</Link>
                                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                                    {loading ? 'Saving...' : 'Save'}
                                                </button>
                                            </div>
                                        </div>
                                    </form >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateTesti